export const BRA_QUIZ_LOCALSTORAGE_KEY = "braQuizResults";
export const SHOW_BRA_RESULTS_MODAL_LOCALSTORAGE_KEY =
  "showBraQuizResultsModal";
